export default "__VITE_ASSET__WfTWnZ1x__"